export default "__VITE_ASSET__7AquMslp__"